import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import responsive from "@styles/responsive"

const NavigationFooter = () => {
  return (
    <Wrapper>
      <ContentfulLogo>
        <a
          href="https://www.contentful.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://images.ctfassets.net/fo9twyrwpveg/7F5pMEOhJ6Y2WukCa2cYws/398e290725ef2d3b3f0f5a73ae8401d6/PoweredByContentful_DarkBackground.svg"
            style={{ maxWidth: "100px", width: "100%" }}
            alt="Powered by Contentful"
          />
        </a>
      </ContentfulLogo>
      <NavList>
        <NavItem>
          <Link to="/">Home</Link>
        </NavItem>
        <NavItem>
          <Link to="/rich-text">Rich Text</Link>
        </NavItem>
        <NavItem>
          <Link to="/markdown">Markdown</Link>
        </NavItem>
      </NavList>
    </Wrapper>
  )
}

export default NavigationFooter

const Wrapper = styled.div`
  background: ${props => props.theme.colors.header};
  display: flex;
  justify-content: space-between;
  padding: 4rem;
  margin-top: 2rem;

  ${responsive.sm} {
    flex-direction: column-reverse;
    justify-content: center;
  }
`

const ContentfulLogo = styled.div`
  ${responsive.sm} {
    text-align: center;
    padding-top: 4rem;
  }
`

const NavList = styled.ul`
  display: flex;
  text-align: center;

  ${responsive.sm} {
    flex-direction: column;
  }
`

const NavItem = styled.li`
  color: ${props => props.theme.colors.white};
  font-size: 1.6rem;
  padding-left: 3.2rem;

  ${responsive.sm} {
    padding: 1.2rem 0;
  }
`
